import React, { useEffect, useState } from "react";
import { imgBaseUrl } from "../../../api/api";
import { formatToDate } from "../../master/FormatToDateTime";
import "./EnquiryForm1.css";

export default function EnquiryDemoForm1({ data }) {
  const [setting, setSetting] = useState({});

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? {}));
  }, []);
  return (
    <>
      <style>
        {`
          .a4-page-enquiry::before {
            background-image: url(${imgBaseUrl + setting?.logo_img});
            }
          `}
      </style>

      <div className="a4-page-enquiry p-3" id="PrintDiv">
        <div className="row g-1 overflow-hidden">
          {setting?.enquiry_demo_header_logo ? (
            <div className="col-12 text-center">
              <img
                src={imgBaseUrl + setting?.enquiry_demo_header_logo}
                alt=""
                style={{ width: "100%" }}
              />
            </div>
          ) : (
            <>
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-center">
                  <img
                    src={imgBaseUrl + setting?.logo_img}
                    style={{ width: "200px", height: "100px", objectFit: "contain" }}
                    alt=""
                  />
                  <div className="text-center">
                    <p className="m-0 ri-30px fw-bold">{setting?.name}</p>
                    <p className="m-0 ri-16px fw-bold">
                      {setting?.village} {setting?.district} {setting?.state}{" "}
                      {setting?.pin_code}
                    </p>
                    <p className="m-0 ri-16px fw-bold">
                      Mobile No : {setting?.mobile}{" "}
                      {setting?.secondary_mobile &&
                        `, ${setting?.secondary_mobile}`}{" "}
                    </p>
                    <p className="m-0 ri-16px fw-bold">
                      Email : {setting?.email}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 border-top"></div>
              <div className="col-12">
                <div className="row align-items-center text-center">
                  <div className="col-4">
                    <h5 className="text-primary m-0">Student Details</h5>
                  </div>
                  <div className="col-4">
                    <span className="badge bg-primary fs-6">
                      Student Demo Form
                    </span>
                  </div>
                  <div className="col-4">
                    <h5 className="text-primary m-0">Student Copy</h5>
                  </div>
                </div>
              </div>
              <div className="col-12 border-bottom"></div>
            </>
          )}
          <div className="col-12 p-0 m-0 mt-2">
            <div className="row me-0 pe-0 mb-2">
              <div className="col-2 fw-bold">Enquiry No</div>
              <div
                className="col-auto border rounded-1"
                style={{ minWidth: "80px" }}
              >
                {data?.enquiry_no}
              </div>
              <div className="col"></div>
              <div className="col-2 fw-bold text-end">Enquiry Date</div>
              <div
                className="col-auto border rounded-1"
                style={{ minWidth: "120px" }}
              >
                {formatToDate(data?.enquiry_date)}
              </div>
            </div>
            <div className="row me-0 pe-0 mb-2">
              <div className="col-2 fw-bold">Student Name</div>
              <div
                className="col-auto border rounded-1"
                style={{ minWidth: "150px" }}
              >
                {data?.student_name}
              </div>
            </div>
            <div className="row me-0 pe-0 mb-2">
              <div className="col-2 fw-bold">Parents Name</div>
              <div
                className="col-auto border rounded-1"
                style={{ minWidth: "170px" }}
              >
                {data?.father_name}
              </div>
            </div>

            <div className="row me-0 pe-0 mb-2">
              <div className="col-2 fw-bold">Address</div>
              <div
                className="col-auto border rounded-1"
                style={{ minWidth: "300px" }}
              >
                {[data?.village, data?.district, data?.state]
                  .filter(Boolean)
                  .join(", ")}
              </div>
            </div>

            <div className="row me-0 pe-0 mb-2">
              <div className="col-2 fw-bold">Gender</div>
              <div className="col-2 border rounded-1">{data?.gender}</div>

              <div className="col-3 text-end fw-bold">Category</div>
              <div className="col-1 border rounded-1">{data?.category}</div>

              <div className="col-2 text-end fw-bold">Mobile</div>
              <div className="col-2 border rounded-1">{data?.mobile}</div>
            </div>

            <div className="row me-0 pe-0 mb-2">
              <div className="col-3 fw-bold pe-0">
                Admission For Course/Class
              </div>
              <div className="col-9 border rounded-1">
                {data?.course?.title}
              </div>
            </div>
            <div className="row me-0 pe-0 mb-2">
              <div className="col-3 fw-bold">Prev. Institute/School</div>
              <div className="col-9 border rounded-1">
                {data?.last_institute_name}
              </div>
            </div>
            <div className="row me-0 pe-0 mb-2">
              <div className="col-2 fw-bold">Medium</div>
              <div
                className="col-auto border rounded-1"
                style={{ minWidth: "70px" }}
              >
                {data?.medium}
              </div>
              <div className="col-3"></div>
              <div className="col-1 fw-bold">Hostel</div>
              <div
                className="col-auto border rounded-1"
                style={{ minWidth: "50px" }}
              >
                {data?.hostel_status}
              </div>
            </div>
            <div className="row me-0 pe-0 mb-0">
              <div className="col-2 fw-bold">Demo Days</div>
              <div className="col-auto border rounded-1">{data?.demo_days}</div>
            </div>
            <div className="col-12 text-end fw-bold mb-1">
              {setting?.auto_signature === "Yes" &&
                setting?.signature && (
                  <img
                    src={imgBaseUrl + setting.signature}
                    alt="Signature"
                    style={{
                      width: "100px",
                      height: "40px",
                      objectFit: "contain",
                      display: "block",
                      marginLeft: "auto",
                    }}
                  />
                )}
              Auth. Signature
            </div>
            {/* <div className="col-12 text-end fw-bold mb-1">Auth. Signature</div> */}
            <div className="col-12">
              This card is valid for demo students only for {data?.demo_days}{" "}
              demo days. Please bring this card during demo classes. Demo access
              will expire after the demo period. Admission is required to
              continue classes.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
